var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22,7.6v1h-2.5c-0.3,0-0.6,0.2-0.6,0.5v2.1c-5,1.4-8.8,5.6-9.6,10.8H7.6c-0.3,0-0.5,0.2-0.5,0.5v3.1 c0,0.3,0.2,0.5,0.5,0.5h29.9c0.3,0,0.5-0.2,0.5-0.5v-3.1c0-0.3-0.2-0.5-0.5-0.5h-1.7c-0.8-5.2-4.6-9.4-9.6-10.8V9.1 c0-0.3-0.3-0.5-0.6-0.5H23v-1H22z M25,9.6v6.7h1.1v-4.1c4.6,1.5,8,5.5,8.6,10.3c0.1,0.3,0.3,0.5,0.5,0.5H37v2H8.1v-2h1.7 c0.3,0,0.5-0.2,0.5-0.5c0.6-4.8,4-8.8,8.6-10.3v4.1H20V9.6h2v4.6H23V9.6H25z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M38,29.7c0-0.3-0.2-0.5-0.5-0.5h-2.6v-1c0-0.3-0.2-0.5-0.5-0.5H10.6c-0.3,0-0.5,0.2-0.5,0.5v1H7.6 c-0.3,0-0.5,0.2-0.5,0.5v3.1c0,0.3,0.2,0.6,0.5,0.6h2.6v0.5c0,0.1,0,0.2,0.1,0.3l2,3c0.1,0.2,0.3,0.3,0.5,0.3h6.1 c0.2,0,0.4-0.1,0.4-0.2l2.1-2.6h0.1l0.9-2.3h0.3l0.9,2.3h0.1l2.1,2.6c0.1,0.1,0.2,0.2,0.4,0.2h6.1c0.2,0,0.4-0.1,0.5-0.3l2-3 c0.1-0.1,0.1-0.2,0.1-0.3v-0.5h2.6c0.3,0,0.5-0.3,0.5-0.6V29.7z M33.8,33.7L32,36.3h-5.7L24.5,34l-1-2.5c0-0.2-0.2-0.3-0.4-0.3H22 c-0.2,0-0.4,0.1-0.4,0.3l-1,2.5l-1.9,2.3H13l-1.8-2.7v-5h22.7V33.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBE900",
  d: "M23,14.2H22V9.6h-2v6.7h-1.1v-4.1c-4.6,1.5-8,5.5-8.6,10.3c0,0.3-0.2,0.5-0.5,0.5H8.1v2H37v-2h-1.7 c-0.2,0-0.4-0.2-0.5-0.5c-0.6-4.8-4-8.8-8.6-10.3v4.1H25V9.6h-2V14.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M33.8,29.7v-1H11.1v5l1.8,2.7h5.7l1.9-2.3l1-2.5c0-0.2,0.2-0.3,0.4-0.3H23c0.2,0,0.4,0.1,0.4,0.3l1,2.5 l1.9,2.3H32l1.8-2.7V29.7z"
});

function SvgSafetyConcern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyConcern);
export default __webpack_public_path__ + "static/media/safety-concern.64c4ec2cfba682ffd4e8b760f8c47fde.svg";
export { ForwardRef as ReactComponent };